import { ReactElement, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Layout, Menu, Image, Descriptions, Input, Space, Breadcrumb } from "antd";
import { HomeOutlined, UserOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { getAuthState, getProductState, getCategoryState } from "../../redux/selectors";
import {SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";
import "../../assets/css/index.css";
import api from "../../redux/api/axiosInstance";
import { ShopHeaderBar, ShopSideBar } from "../../components";
import product from "../../redux/reducer/product";
import Loading from "../../components/Loading";

export function CommunityShop(): ReactElement {
    
const dispatch = useDispatch();
const history = useHistory();
const { t } = useTranslation();
const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { categoryId } = useParams<{ categoryId: string }>();
const { Meta } = Card;
const { currentUser } = useSelector(getAuthState);
const [loading, setLoading] = useState<boolean>(false);
const [products, setProducts] = useState<any[]>([]);
const [clubs, setClubs] = useState<any[]>([]);
const { Search } = Input;
const [spinner, setSpinner] = useState<boolean>(false);

const getProducts = async () => {
    await api.post("getProducts", { category: "0", type : "regular"})
    .then(res => {
        setProducts(res.data.productData);
    })
    .catch(e => {
        console.log(e);
    })
}

const init = async () => {
    setLoading(true);
    await getProducts();
    setLoading(false);
}

useEffect(() => {
    init();
}, []);


const goProductDetail = (record: any) => {
    history.push(`/shop/product/${record}`);
};

const getCategoryProduct = async (catId:any) => {
    await api.post("getProducts", { category: catId, name: "", type : "regular"})
    .then(res => {
        setProducts(res.data.productData);
    })
    .catch(e => {
        console.log(e);
    })
}

const onSearch = async (name:any) => {
    setSpinner(true);
    await api.post("getProducts", { category: "0", type : "regular"})
    .then(res => {
        const searchedProduct = res.data.productData;
        const productData = searchedProduct.filter((pro:any)=> {
            return pro.name.toLowerCase().includes(name.toLowerCase()) || pro.tags.join(",").toLowerCase().includes(name.toLowerCase());
        });
        setSpinner(false);
        setProducts(productData);
    })
    .catch(e => {
        console.log(e);
    })
}

return (
    <Layout>
        {loading && <Loading /> }
        {!currentUser && <ShopHeaderBar /> }
        <Content style={{ margin: '50px 16px 50px', minHeight: currentUser ? "" : "100vh"}}>
            <Row justify="center">
                <Col xs={24} sm={24} md={24} lg={16} xl={currentUser ? 24: 18}>
                    <Row gutter={[20,10]}>
                        <Col span={24}>
                            <Breadcrumb>
                                <Breadcrumb.Item href="">
                                    <HomeOutlined />
                                </Breadcrumb.Item>
                                <Breadcrumb.Item href="">
                                    <span>Shop</span>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>Community Shop</Breadcrumb.Item>
                            </Breadcrumb>
                            
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={8} xl={4} style={{marginTop:30}}>
                            <Row gutter={[20,10]}  style={{marginBottom:30}}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Search
                                        placeholder="Search product"
                                        allowClear
                                        enterButton="Search"
                                        loading={spinner}
                                        onSearch={(text) => onSearch(text)}
                                    />
                                </Col>
                            </Row>
                            <ShopSideBar getCategoryPro={getCategoryProduct} />
                        </Col>
                        <Col  xs={24} sm={24} md={24} lg={16} xl={20}>
                            <Row gutter={[20,10]} style={{marginTop:30}}>
                                {products.map(({product_id,name,cost,photo,currency}) => 
                                    <Col xs={24} sm={12} md={12} lg={12} xl={6}>
                                        <Card
                                            style={{width:"100%",color:"white"}}
                                            hoverable
                                            cover={<img className="shop-product-image" alt="example" src={photo} />}
                                            onClick={() => goProductDetail(product_id)}
                                        >
                                            <Meta title={name} description={currency+cost} />
                                        </Card>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Content>
    </Layout>
  );
}
